import { QueryFilter } from '@softline/core';
import { DeliveryNoteQueryRow } from '../types/delivery-note-query-row';

const STATUS_FIELD = 'delivery_note.status';

const codeOf = (value: unknown): unknown =>
  value && typeof value === 'object' && 'code' in value ? (value as { code: unknown }).code : value;

/** The backend lists `delivery_note.status` as `{ code, displayName, name }` but filters only by the
 *  code: a filter naming that column gets the codes instead of the objects the page filter holds. */
export function statusFilterAsCodes(
  filter: QueryFilter<DeliveryNoteQueryRow> | null | undefined
): QueryFilter<DeliveryNoteQueryRow> | null {
  if (!filter) return null;
  const node = filter as unknown as Record<string, unknown>;
  if (Array.isArray(node['filters'])) {
    return { ...node, filters: (node['filters'] as QueryFilter<DeliveryNoteQueryRow>[]).map((one) => statusFilterAsCodes(one)) } as unknown as QueryFilter<DeliveryNoteQueryRow>;
  }
  if (node['name'] !== STATUS_FIELD) return filter;
  const mapped: Record<string, unknown> = { ...node };
  if (Array.isArray(node['values'])) mapped['values'] = (node['values'] as unknown[]).map(codeOf);
  if ('value' in node) mapped['value'] = codeOf(node['value']);
  return mapped as unknown as QueryFilter<DeliveryNoteQueryRow>;
}
